<template>
	<header class="pt-600-smo pt-800-md pb-400 bg-color-content-primary text-color-white">
		<div class="container display-flex-md align-items-center">
			<div class="text-align-center-smo col-12-smo col-7-md">
				<div v-reveal:fade-up>
					<h1 class="heading-1"> Opportunistic Credit Fund </h1>
					<p class="body-xl mt-25-md mt-100-smo"> A private lending fund calibrated for today’s market </p>
					<p class="body-lg">
						Income-focused investors can now directly take advantage of the significant dislocation in real
						estate credit markets.
					</p>
					<LeadCaptureOcf button-color="button-primary" />
				</div>
			</div>
			<div class="col-12-smo col-offset-1-md col-4-md mt-250-smo">
				<div v-reveal:fade-up class="bb bt br bl border-color-reversed">
					<table class="display-block px-100 pt-100">
						<thead class="display-block mb-50">
							<strong class="text-transform-uppercase"> Fund structure </strong>
						</thead>
						<tbody class="display-block">
							<tr
								v-for="(detail, index) in fundStructureDetails"
								:key="index"
								class="border-color-reversed body-sm display-flex justify-content-space-between py-100"
								:class="{ bt: index !== 0 }"
							>
								<span v-html="detail.key" />
								<span class="font-weight-bold text-align-right" v-html="detail.value" />
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</header>
</template>

<script setup lang="ts">
import LeadCaptureOcf from '@components/lead-capture/lead-capture-ocf.vue';
const fundStructureDetails: Array<{ key: string; value: string }> = [
	{
		key: 'Current Dividend',
		value: '12.5%'
	},
	{
		key: 'Term',
		value: '5-7 years'
	},
	{
		key: 'Minimum Initial Investment',
		value: '$100,000'
	},
	{
		key: 'Distribution Frequency',
		value: 'Quarterly'
	},
	{
		key: 'Liquidity',
		value: 'None'
	},
	{
		key: 'Asset Management Fee',
		value: '1.75%'
	},
	{
		key: 'Management Incentive Fee',
		value: '20% over 10% <br> preferred return'
	}
];
</script>
<style lang="scss" scoped>
@use '../../../styles/utilities/respond-to.scss' as *;

@include respond-to(md) {
	.pt-800-md {
		padding-top: 8rem;
	}
}
</style>
